const initialState = {
  items: [],
  loading: false,
  error: null,
  lastFetchedAt: null
};

export default function categoriesReducer(state = initialState, action) {
  switch (action.type) {
    case "CATEGORIES/FETCH_START":
      return { ...state, loading: true, error: null };
    case "CATEGORIES/FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
        items: action.payload,
        lastFetchedAt: Date.now()
      };
    case "CATEGORIES/FETCH_ERROR":
      return { ...state, loading: false, error: action.payload || "Unknown error" };
    default:
      return state;
  }
}

